var dropdownItem = 'fx_2d2fb1e5_x6ok2c0';
var dropdownItemClickable = 'fx_2d2fb1e5_x6ok2c1';
var dropdownItemContent = 'fx_2d2fb1e5_x6ok2c2';

export { dropdownItem, dropdownItemClickable, dropdownItemContent };
//# sourceMappingURL=item.vanilla.mjs.map
